var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBreachRiskInquiriesBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1313.002 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.1,135V33H39.8V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.671,135V63.6H80.136l17.22,58.8h1.05V63.6H112.9V135H89.062L71.211,76.2h-1.05V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.795,136.26q-16.38,0-22.995-8.82t-6.614-27.772q0-18.953,6.667-28.141t22.942-9.187q16.275,0,22.943,9.187t6.667,28.194q0,23.309-11.025,31.394l8.715,14.071-13.23,6.194-9.449-15.435A20.57,20.57,0,0,1,152.795,136.26Zm-11.6-18.06q3.1,5.461,11.6,5.46t11.6-5.46q3.1-5.457,3.1-18.479t-3.151-18.9q-3.148-5.88-11.55-5.88t-11.549,5.88q-3.15,5.882-3.151,18.9T141.193,118.2Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.555,111.165q0,12.5,12.7,12.495t12.705-12.495V63.6h14.49v47.25q0,13.127-6.773,19.267T219.26,136.26q-13.651,0-20.423-6.142t-6.772-19.267V63.6h14.49Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.264,135V63.6h14.49V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.683,111.061V135h-14.49V63.6h27.721q25.2,0,25.2,23.519,0,13.966-10.5,20.58L339.8,135H323.943l-8.295-23.939Zm21.106-15.54a12.89,12.89,0,0,0,2.519-8.3,11.964,11.964,0,0,0-2.677-8.191q-2.677-3.043-7.717-3.045H301.683V98.67h13.441Q320.266,98.67,322.789,95.521Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.193,135V63.6h14.49V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.123,135V63.6h46.2V76.2H392.612V92.9h25.41v12.389h-25.41V122.4h31.711V135Z",
    style: {
      fill: "#5e1513"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.136,74.94q-11.447,0-11.445,7.56a5.726,5.726,0,0,0,2.835,5.146q2.835,1.785,13.283,5.144t14.647,7.612q4.2,4.252,4.2,13.074,0,11.237-6.825,17.009t-17.85,5.775a99.321,99.321,0,0,1-20.055-2.52l-3.78-.735,1.47-11.234a174.928,174.928,0,0,0,21.525,1.889q11.128,0,11.13-9.24a6.151,6.151,0,0,0-2.573-5.25q-2.574-1.89-10.237-4.095-12.182-3.463-17.168-8.242T430.306,83.55q0-10.71,6.51-15.96t17.85-5.25a118.717,118.717,0,0,1,19.74,2.1l3.78.735L477.031,76.62Q462.226,74.942,456.136,74.94Z",
    style: {
      fill: "#5e1513"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreachRiskInquiriesBanner);
export default __webpack_public_path__ + "static/media/BreachRisk_Inquiries_Banner.1758f69218963b016216f2d3d70d8b35.svg";
export { ForwardRef as ReactComponent };